class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector("details");
		this.summaryToggle = this.querySelector("summary");

		this.detailsContainer.addEventListener(
			"keyup",
			(event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
		);
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this),
		);
		if (this.querySelector('button[type="button"]')) {
			this.querySelector('button[type="button"]').addEventListener(
				"click",
				this.close.bind(this),
			);
		}

		this.summaryToggle.setAttribute("role", "button");
		this.summaryToggle.setAttribute("aria-expanded", "false");
	}

	isOpen() {
		return this.detailsContainer.hasAttribute("open");
	}

	onSummaryClick(event) {
		event.preventDefault();
		event.target.closest("details").hasAttribute("open")
			? this.close()
			: this.open(event);
	}

	onBodyClick(event) {
		if (!this.contains(event.target)) this.close(false);
	}

	open(event) {
		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest("details").setAttribute("open", true);

		const focusContainer = this.detailsContainer.querySelector(
			'[tabindex="-1"]',
		);
		const focusTarget = this.detailsContainer.querySelector(
			'input:not([type="hidden"])',
		);

		// Defer body listener so the opening click does not immediately close.
		// Focus on the next frame so the modal is painted and the caret is visible.
		requestAnimationFrame(() => {
			document.body.addEventListener("click", this.onBodyClickEvent);
			trapFocus(focusContainer, focusTarget);
		});
	}

	close(focusToggle = true) {
		const header = document.querySelector(".shopify-section-header");
		let scrollTop = window.scrollY;
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute("open");
		document.body.removeEventListener("click", this.onBodyClickEvent);
		document.body.classList.remove("overflow-hidden");

		if (scrollTop < header.offsetHeight / 2) {
			header.classList.remove(
				"animate",
				"animated",
				"shopify-section-header-sticky",
			);
		}
	}
}

customElements.define("details-modal", DetailsModal);
